// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItemModal-cls1___44fbf86dee76c26ef1a","cls2":"CreateSocialItemModal-cls2__a8f5267ad6ef3b63a5d1 CreateSocialItemModal-cls1___44fbf86dee76c26ef1a"};